import type { ImageClassificationFields } from '@bizzdesign/modeler/models';
import { catchError, EMPTY, from, of, type Observable } from 'rxjs';
import { bufferCount, map, mergeMap } from 'rxjs/operators';
import type { ModelerDataService } from './modeler-data.service';

export type FrameImageDeliverable = {
  id: string;
  imageSrc: string;
  description?: string;
  alt?: string;
} & ImageClassificationFields;

/**
 * Fetches image deliverables for the given imageIds in concurrent batches of 25.
 * Results stream back as each batch resolves. Items whose content could not be
 * resolved (undefined imageSrc) are filtered out.
 */
export function loadFrameImageDeliverables$(
  imageIds: string[],
  modelerDataService: ModelerDataService,
): Observable<FrameImageDeliverable[]> {
  if (!imageIds.length) return EMPTY;

  return from(imageIds).pipe(
    bufferCount(25),
    mergeMap((batch) =>
      modelerDataService.getImageDeliverables(batch).pipe(
        map((results) =>
          results.filter((r): r is FrameImageDeliverable => r.imageSrc != null),
        ),
        catchError((error) => {
          console.error('Error loading image deliverables for batch', error);
          return of([]); // Emit an empty array for this batch on error
        }),
      ),
    ),
  );
}
